import { render } from "./DeactivatedStaffTable.vue?vue&type=template&id=734398db&scoped=true"
import script from "./DeactivatedStaffTable.vue?vue&type=script&lang=js"
export * from "./DeactivatedStaffTable.vue?vue&type=script&lang=js"

import "./DeactivatedStaffTable.vue?vue&type=style&index=0&id=734398db&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734398db"]])

export default __exports__